<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/settings'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div class="gw-space-y-8" *ngIf="fees">
    <!-- Header Section -->
    <div
      class="gw-flex gw-flex-col sm:gw-flex-row sm:gw-items-center sm:gw-justify-between gw-gap-4"
    >
      <!-- Entity Info -->
      <div class="gw-flex gw-items-center gw-gap-3" *ngIf="entity">
        <div
          class="gw-w-12 gw-h-12 gw-rounded-lg gw-bg-primary-brand-background/10 gw-flex gw-items-center gw-justify-center gw-flex-shrink-0"
        >
          <gatewee-icon
            icon="@tui.building"
            size="20px"
            iconStyle="primary"
          ></gatewee-icon>
        </div>
        <div>
          <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
            {{ entity.name || '' }}
          </h2>
          <p class="gw-text-sm gw-text-text-secondary">
            {{ entity.document || '' | document }}
          </p>
        </div>
      </div>

      <!-- Edit Mode Toggle -->
      <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-3">
        <div
          *ngIf="editMode"
          class="gw-flex gw-flex-wrap gw-items-center gw-gap-2"
        >
          <select
            *ngIf="unconfiguredIncomeMethodsList.length > 0"
            class="gw-px-3 gw-py-2 gw-text-sm gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1"
            #addMethodSelect
            (change)="onAddIncomeMethodSelect(addMethodSelect)"
          >
            <option value="">
              {{ 'features.fees.addPaymentMethod' | translate }}
            </option>
            <option
              *ngFor="
                let m of unconfiguredIncomeMethodsList;
                trackBy: trackByPaymentMethodOption
              "
              [value]="m"
            >
              {{ getPaymentMethodLabel(m) | translate }}
            </option>
          </select>
          <gatewee-button
            *ngIf="canAddCashOut()"
            variant="outline"
            [title]="'features.fees.addCashOut' | translate"
            (clicked)="addCashOutFee()"
          ></gatewee-button>
        </div>

        <gatewee-button
          *ngIf="!editMode && !hasNoFees()"
          variant="primary"
          [iconName]="'@tui.edit'"
          [title]="'features.fees.editMode' | translate"
          (clicked)="toggleEditMode()"
        ></gatewee-button>

        <gatewee-button
          *ngIf="shouldShowLoadDefaultFeesButton()"
          variant="primary"
          [iconName]="'@tui.download'"
          [title]="'features.fees.loadDefaultFees' | translate"
          (clicked)="loadDefaultFees()"
        ></gatewee-button>

        <gatewee-button
          *ngIf="!editMode && !hasNoFees()"
          variant="outline"
          [iconName]="'@tui.trash'"
          [title]="'features.fees.removeAllFees' | translate"
          (clicked)="removeAllFees()"
        ></gatewee-button>
        <div *ngIf="editMode" class="gw-flex gw-gap-3">
          <gatewee-button
            variant="outline"
            [title]="'common.actions.cancel' | translate"
            (clicked)="cancelEdit()"
          ></gatewee-button>
          <gatewee-button
            variant="primary"
            [title]="'common.actions.save' | translate"
            [disabled]="!feesForm.valid"
            (clicked)="saveFees()"
          ></gatewee-button>
        </div>
      </div>
    </div>

    <!-- Standard Payment Methods Fees -->
    <div
      class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-1"
      *ngIf="fees && (scope === 'domain' || displayEditableFees.length > 0)"
    >
      <div class="gw-px-6 gw-py-4 gw-border-b gw-border-border-normal">
        <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary">
          {{
            scope === 'domain'
              ? ('features.fees.standardPaymentMethods' | translate)
              : ('features.fees.recipientFees' | translate)
          }}
        </h3>
      </div>

      <div class="gw-p-6">
        <div
          *ngIf="displayEditableFees.length > 0"
          class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 lg:gw-grid-cols-3 gw-gap-4"
        >
          <div
            *ngFor="
              let fee of displayEditableFees;
              let i = index;
              trackBy: trackByEditableFee
            "
            class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-p-5 gw-bg-background-elevation-1 hover:gw-bg-background-elevation-2 gw-border-base"
          >
            <div class="gw-flex gw-items-center gw-justify-between gw-mb-4">
              <div class="gw-flex-1">
                <h4
                  class="gw-text-base gw-font-semibold gw-text-text-primary gw-mb-1"
                >
                  <span *ngIf="fee.operation === 'cash_out'">
                    {{ 'features.fees.operations.cashOut' | translate }}
                  </span>
                  <span *ngIf="fee.operation !== 'cash_out'">
                    {{ fee.paymentMethod | paymentMethod }}
                  </span>
                </h4>
              </div>
              <div class="gw-flex gw-items-center gw-gap-2">
                <gatewee-button
                  *ngIf="editMode"
                  variant="outline"
                  [iconName]="'@tui.trash'"
                  [title]="'common.actions.remove' | translate"
                  (clicked)="removeStandardFee(getFeeFormKey(fee))"
                ></gatewee-button>
                <div
                  class="gw-flex gw-items-center gw-justify-end gw-min-w-[200px]"
                >
                  <ng-container *ngIf="!editMode">
                    <div
                      class="gw-text-3xl gw-font-bold gw-text-right"
                      [class.gw-text-primary-brand]="fee.type === 'rate'"
                      [class.gw-text-status-success]="fee.type === 'amount'"
                    >
                      {{ formatFeeByType(fee.type, getFeeValue(fee)) }}
                    </div>
                  </ng-container>
                  <ng-container *ngIf="editMode && getFeeFormControl(fee)">
                    <div class="gw-flex gw-items-center gw-gap-2.5">
                      <select
                        *ngIf="getFeeTypeControl(fee)"
                        [formControl]="getFeeTypeControl(fee)!"
                        [attr.aria-label]="'features.fees.feeType' | translate"
                        class="gw-px-3 gw-py-2.5 gw-text-base gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary-brand-border"
                      >
                        <option value="rate">%</option>
                        <option value="amount">R$</option>
                      </select>
                      <div class="gw-relative">
                        <span
                          *ngIf="getFeeTypeControl(fee)?.value === 'rate'"
                          class="gw-absolute gw-left-3.5 gw-top-1/2 gw-transform -gw-translate-y-1/2 gw-text-text-secondary gw-text-base gw-font-medium gw-pointer-events-none"
                        >
                          %
                        </span>
                        <span
                          *ngIf="getFeeTypeControl(fee)?.value === 'amount'"
                          class="gw-absolute gw-left-3.5 gw-top-1/2 gw-transform -gw-translate-y-1/2 gw-text-text-secondary gw-text-base gw-font-medium gw-pointer-events-none"
                        >
                          R$
                        </span>
                        <input
                          *ngIf="getFeeValueControl(fee)"
                          type="number"
                          [formControl]="getFeeValueControl(fee)!"
                          [max]="
                            getFeeTypeControl(fee)?.value === 'rate'
                              ? 100
                              : null
                          "
                          [min]="0"
                          step="0.01"
                          [attr.aria-label]="
                            'features.fees.feeValue' | translate
                          "
                          class="gw-w-32 gw-pl-12 gw-pr-3 gw-py-2.5 gw-text-lg gw-font-semibold gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary-brand-border"
                        />
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <ng-container
              *ngIf="
                scope === 'recipient' &&
                getDomainFeeForMethod(fee.paymentMethod!)
              "
            >
              <div
                class="gw-pt-3 gw-border-t gw-border-border-normal gw-space-y-3"
              >
                <div class="gw-flex gw-items-center gw-justify-between">
                  <p class="gw-text-xs gw-text-text-secondary">
                    {{ 'features.fees.base' | translate }}
                  </p>
                  <div
                    class="gw-text-base gw-font-semibold gw-text-primary-brand"
                  >
                    {{
                      formatFeeByType(
                        getDomainFeeForMethod(fee.paymentMethod!)?.type ||
                          'amount',
                        getDomainFeeValue(fee.paymentMethod!)
                      )
                    }}
                  </div>
                </div>
                <div class="gw-flex gw-items-center gw-justify-between">
                  <p class="gw-text-xs gw-text-text-secondary">
                    {{ 'features.fees.markup' | translate }}
                  </p>
                  <div
                    class="gw-text-base gw-font-semibold gw-text-text-primary"
                  >
                    {{ getRecipientMarkupDisplay(fee) }}
                  </div>
                </div>
                <div class="gw-flex gw-items-center gw-justify-between">
                  <p class="gw-text-sm gw-font-medium gw-text-text-primary">
                    {{ 'features.fees.total' | translate }}
                  </p>
                  <div class="gw-text-xl gw-font-bold gw-text-status-success">
                    {{ getTotalFeeDisplay(fee) }}
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          *ngIf="
            scope === 'domain' &&
            displayEditableFees.length === 0 &&
            (!defaultFees || defaultFees.length === 0)
          "
          class="gw-text-center gw-py-8"
        >
          <p class="gw-text-text-secondary">
            {{ 'features.fees.noFeesConfigured' | translate }}
          </p>
        </div>
        <div
          *ngIf="
            scope === 'recipient' &&
            displayEditableFees.length === 0 &&
            (!defaultFees || defaultFees.length === 0)
          "
          class="gw-text-center gw-py-8"
        >
          <p class="gw-text-text-secondary">
            {{ 'features.fees.noFeesConfigured' | translate }}
          </p>
        </div>
      </div>
    </div>

    <!-- Credit Card Fees (matrix) -->
    <div
      class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-border-base"
      *ngIf="showCreditCardSection()"
    >
      <div
        class="gw-px-6 gw-py-4 gw-border-b gw-border-border-normal gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-3"
      >
        <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary">
          {{ 'features.fees.creditCardFees' | translate }}
        </h3>
        <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-2">
          <gatewee-button
            *ngIf="editMode"
            variant="outline"
            [title]="'features.fees.addInstallmentRow' | translate"
            (clicked)="addCreditCardInstallmentRow()"
          ></gatewee-button>
          <gatewee-button
            *ngIf="!showInstallments13to24"
            variant="outline"
            [title]="'features.fees.showInstallments13to24' | translate"
            (clicked)="toggleInstallments13to24()"
          ></gatewee-button>
          <gatewee-button
            *ngIf="showInstallments13to24"
            variant="outline"
            [title]="'features.fees.hideInstallments13to24' | translate"
            (clicked)="toggleInstallments13to24()"
          ></gatewee-button>
        </div>
      </div>

      <div
        class="gw-p-6 gw-bg-background-elevation-1"
        *ngIf="!creditCardMatrixVisible() && !editMode"
      >
        <p class="gw-text-text-secondary gw-mb-4">
          {{ 'features.fees.creditCardEmptyHint' | translate }}
        </p>
        <gatewee-button
          variant="primary"
          [title]="'features.fees.configureCreditCard' | translate"
          (clicked)="startConfigureCreditCard()"
        ></gatewee-button>
      </div>

      <div
        class="gw-p-6 gw-bg-background-elevation-1 gw-cc-matrix-scroll gw-overflow-x-auto"
        *ngIf="creditCardMatrixVisible()"
      >
        <table class="gw-w-full gw-cc-matrix gw-table-fixed">
          <colgroup>
            <col class="gw-cc-col-installments" />
            <col class="gw-cc-col-fee" />
          </colgroup>
          <thead>
            <tr class="gw-border-b gw-border-border-normal">
              <th
                class="gw-cc-sticky gw-text-left gw-px-4 gw-py-3 gw-text-sm gw-font-semibold gw-text-text-primary gw-bg-background-elevation-1"
              >
                {{ 'features.fees.installments' | translate }}
              </th>
              <th
                class="gw-text-left gw-px-4 gw-py-3 gw-text-sm gw-font-semibold gw-text-text-primary"
              >
                {{ 'features.fees.brandless' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let tier of ccMatrixRows; trackBy: trackByCcTier"
              class="gw-border-b gw-border-border-normal hover:gw-bg-background-elevation-2 gw-transition-colors"
            >
              <td
                class="gw-cc-sticky gw-cc-install-cell gw-px-3 gw-py-2.5 gw-bg-background-elevation-1 gw-align-middle gw-overflow-hidden"
              >
                <div class="gw-cc-install-inner">
                  <span
                    class="gw-font-medium gw-text-text-primary gw-whitespace-nowrap gw-block"
                  >
                    {{ formatTierLabel(tier) }}
                  </span>
                  <gatewee-button
                    *ngIf="editMode && tier !== 'default'"
                    variant="outline"
                    size="s"
                    [iconName]="'@tui.trash'"
                    [title]="''"
                    [attr.aria-label]="
                      'features.fees.removeInstallmentRow' | translate
                    "
                    [attr.title]="
                      'features.fees.removeInstallmentRow' | translate
                    "
                    class="gw-cc-row-remove gw-mt-1.5 gw-self-start"
                    (clicked)="removeCcInstallmentRow(tier)"
                  ></gatewee-button>
                </div>
              </td>
              <td class="gw-px-4 gw-py-2.5 gw-align-middle">
                <ng-container *ngIf="hasCcFormControl(tier)">
                  <ng-container *ngIf="scope === 'recipient' && !editMode">
                    <div class="gw-cc-fee-metrics">
                      <span class="gw-cc-metric">
                        <span class="gw-cc-metric-label">{{
                          'features.fees.base' | translate
                        }}</span>
                        <span class="gw-cc-metric-value">{{
                          formatFeeByType(
                            getCcDomainType(tier),
                            getCcDomainValue(tier)
                          )
                        }}</span>
                      </span>
                      <span class="gw-cc-metric">
                        <span class="gw-cc-metric-label">{{
                          'features.fees.markup' | translate
                        }}</span>
                        <span class="gw-cc-metric-value">{{
                          formatFeeByType(
                            getCcRecipientType(tier),
                            getCcRecipientValue(tier)
                          )
                        }}</span>
                      </span>
                      <span class="gw-cc-metric gw-cc-metric-total">
                        <span class="gw-cc-metric-label">{{
                          'features.fees.total' | translate
                        }}</span>
                        <span class="gw-cc-metric-value gw-text-status-success">
                          {{ getCcTotalDisplay(tier) }}
                        </span>
                      </span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="scope === 'domain' && !editMode">
                    <div
                      class="gw-text-base gw-font-bold gw-tabular-nums"
                      [class.gw-text-primary-brand]="
                        getCcDomainType(tier) === 'rate'
                      "
                    >
                      {{
                        formatFeeByType(
                          getCcDomainType(tier),
                          getCcDomainValue(tier)
                        )
                      }}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="editMode && getCcFormGroup(tier)">
                    <div class="gw-cc-edit-cell">
                      <div
                        *ngIf="scope === 'recipient'"
                        class="gw-cc-edit-base gw-text-xs gw-text-text-secondary"
                      >
                        <span class="gw-font-medium gw-text-text-primary">{{
                          'features.fees.base' | translate
                        }}</span>
                        {{
                          formatFeeByType(
                            getCcDomainType(tier),
                            getCcDomainValue(tier)
                          )
                        }}
                      </div>
                      <div class="gw-cc-edit-controls">
                        <select
                          *ngIf="getCcTypeControl(tier)"
                          [formControl]="getCcTypeControl(tier)!"
                          class="gw-cc-type-select gw-px-2 gw-py-1.5 gw-text-sm gw-border gw-border-border-normal gw-rounded-md gw-bg-background-elevation-1"
                        >
                          <option value="rate">%</option>
                          <option value="amount">R$</option>
                        </select>
                        <input
                          *ngIf="getCcValueControl(tier)"
                          type="number"
                          [formControl]="getCcValueControl(tier)!"
                          [max]="
                            getCcTypeControl(tier)?.value === 'rate'
                              ? 100
                              : null
                          "
                          [min]="0"
                          step="0.01"
                          class="gw-cc-value-input gw-min-w-0 gw-flex-1 gw-max-w-[7rem] gw-px-2 gw-py-1.5 gw-text-sm gw-font-semibold gw-tabular-nums gw-border gw-border-border-normal gw-rounded-md gw-bg-background-elevation-1"
                        />
                        <gatewee-button
                          variant="outline"
                          class="gw-cc-remove-btn gw-shrink-0"
                          [title]="'common.actions.remove' | translate"
                          (clicked)="removeCcCell(tier)"
                        ></gatewee-button>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="
                    !hasCcFormControl(tier) &&
                    editMode &&
                    canConfigureCcCell(tier)
                  "
                >
                  <gatewee-button
                    variant="outline"
                    [title]="'features.fees.addFeeCell' | translate"
                    (clicked)="addCcCell(tier)"
                  ></gatewee-button>
                </ng-container>
                <span
                  *ngIf="!hasCcFormControl(tier) && !editMode"
                  class="gw-text-text-secondary gw-text-sm"
                  >—</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Custom Fee Form Template (if provided) -->
    <div
      class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
      *ngIf="feeFormTemplate"
    >
      <div
        class="gw-px-6 gw-py-4 gw-border-b gw-border-border-normal gw-bg-background-elevation-1"
      >
        <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary">
          {{ 'features.fees.configuration' | translate }}
        </h3>
        <p class="gw-text-sm gw-text-text-secondary gw-mt-1">
          {{ 'features.fees.configurationDescription' | translate }}
        </p>
      </div>
      <div class="gw-p-6">
        <ng-container *ngTemplateOutlet="feeFormTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- Remove Fees Confirmation Dialog -->
<ng-template #removeFeesDialog let-observer>
  <div class="gw-space-y-4">
    <p class="gw-text-text-primary">
      {{ 'features.fees.removeAllFeesConfirmMessage' | translate }}
    </p>
    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (click)="observer.next(false); observer.complete()"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'features.fees.removeAllFees' | translate"
        (click)="observer.next(true); observer.complete()"
      ></gatewee-button>
    </div>
  </div>
</ng-template>
